import { CallbackSuccessHandler, FetchResult, useFetchCallback } from 'json-api-hooks';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';

import useSnackbar from '../../../hooks/useSnackbar';
import CardContent from '../../Card/CardContent';
import CardMain from '../../Card/CardMain';
import Container from '../../Container';
import Form from '../../Form/Form';
import parseErrors from '../../Form/lib/parseErrors';
import { FormFieldDefinition } from '../../Form/ResourceForm';
import { InputType } from '../../Form/types';
import Heading from '../../Heading';

const fields: FormFieldDefinition[] = [
  { attribute: 'password', placeholder: '*********', label: 'Nieuw wachtwoord', type: InputType.Password },
  {
    attribute: 'password_confirmation',
    placeholder: '*********',
    label: 'Herhaal nieuw wachtwoord',
    type: InputType.Password,
  },
];

const SetPasswordForm = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const methods = useForm();
  const showSnackbar = useSnackbar();
  const [callback, loading] = useFetchCallback('/u/password', 'PATCH');

  const handleError = ({ json }: FetchResult) => parseErrors(json, fields, methods.setError);

  const handleSuccess: CallbackSuccessHandler = () => {
    showSnackbar('Je wachtwoord is aangepast. Je kan nu inloggen met je nieuwe wachtwoord.');
    navigate('/u/session/new');
  };

  const onSubmit = methods.handleSubmit((data) => {
    callback({ user: { ...data, reset_password_token: params.get('reset_password_token') } })
      .then(handleSuccess)
      .catch(handleError);
  });

  return (
    <Container>
      <CardMain>
        <CardContent endSpacing>
          <Heading>Wachtwoord opnieuw instellen</Heading>
          <Form fields={fields} loading={loading} methods={methods} submitLabel="Instellen" onSubmit={onSubmit} />
        </CardContent>
      </CardMain>
    </Container>
  );
};

export default SetPasswordForm;
